import React, { lazy, Suspense } from 'react';

const LazyAccountInfo = lazy(() => import('./AccountInfo'));

const AccountInfo = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAccountInfo {...props} />
  </Suspense>
);

export default AccountInfo;
